// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DialerRouteImport } from './routes/dialer'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ToolsIndexRouteImport } from './routes/tools/index'
import { Route as ToolsPhoneValidatorRouteImport } from './routes/tools/phone-validator'
import { Route as ToolsCountryCodesRouteImport } from './routes/tools/country-codes'
import { Route as ToolsBestTimeToCallRouteImport } from './routes/tools/best-time-to-call'
import { Route as RatesCountryRouteImport } from './routes/rates/$country'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminTransactionsRouteImport } from './routes/admin/transactions'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminSchedulerRouteImport } from './routes/admin/scheduler'
import { Route as AdminPhoneNumbersRouteImport } from './routes/admin/phone-numbers'
import { Route as AdminCallsRouteImport } from './routes/admin/calls'
import { Route as AdminAffiliatesRouteImport } from './routes/admin/affiliates'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangPricingRouteImport } from './routes/$lang/pricing'
import { Route as LangFaqRouteImport } from './routes/$lang/faq'
import { Route as LangDocsRouteImport } from './routes/$lang/docs'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminPricingIndexRouteImport } from './routes/admin/pricing/index'
import { Route as AdminUsersAccountIdRouteImport } from './routes/admin/users/$accountId'
import { Route as AdminPricingVersionsRouteImport } from './routes/admin/pricing/versions'
import { Route as AdminPricingGenerateRouteImport } from './routes/admin/pricing/generate'
import { Route as AdminAgentConsoleCallIdRouteImport } from './routes/admin/agent-console/$callId'
import { Route as PublicBlogIndexRouteImport } from './routes/_public/blog/index'
import { Route as PublicBlogSlugRouteImport } from './routes/_public/blog/$slug'
import { Route as LangToolsIndexRouteImport } from './routes/$lang/tools/index'
import { Route as LangOpenclawIndexRouteImport } from './routes/$lang/openclaw/index'
import { Route as LangAccountIndexRouteImport } from './routes/$lang/account/index'
import { Route as LangToolsPhoneValidatorRouteImport } from './routes/$lang/tools/phone-validator'
import { Route as LangToolsCountryCodesRouteImport } from './routes/$lang/tools/country-codes'
import { Route as LangToolsBestTimeToCallRouteImport } from './routes/$lang/tools/best-time-to-call'
import { Route as LangRatesCountryRouteImport } from './routes/$lang/rates/$country'
import { Route as LangOpenclawSetupRouteImport } from './routes/$lang/openclaw/setup'
import { Route as LangAccountSettingsRouteImport } from './routes/$lang/account/settings'
import { Route as LangAccountReferralsRouteImport } from './routes/$lang/account/referrals'
import { Route as LangAccountNumbersRouteImport } from './routes/$lang/account/numbers'
import { Route as LangAccountBillingRouteImport } from './routes/$lang/account/billing'
import { Route as LangAccountApiRouteImport } from './routes/$lang/account/api'
import { Route as LangDocsIndexRouteImport } from './routes/$lang/docs/index'
import { Route as LangDocsApiReferenceRouteImport } from './routes/$lang/docs/api-reference'
import { Route as LangDocsDocSlugRouteImport } from './routes/$lang/docs/$docSlug'
import { Route as LangOpenclawUseCasesIndexRouteImport } from './routes/$lang/openclaw/use-cases/index'
import { Route as LangOpenclawUseCasesCategoryRouteImport } from './routes/$lang/openclaw/use-cases/$category'

const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DialerRoute = DialerRouteImport.update({
            id: '/dialer',path: '/dialer',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsPhoneValidatorRoute = ToolsPhoneValidatorRouteImport.update({
            id: '/tools/phone-validator',path: '/tools/phone-validator',getParentRoute: () => rootRouteImport
          })
const ToolsCountryCodesRoute = ToolsCountryCodesRouteImport.update({
            id: '/tools/country-codes',path: '/tools/country-codes',getParentRoute: () => rootRouteImport
          })
const ToolsBestTimeToCallRoute = ToolsBestTimeToCallRouteImport.update({
            id: '/tools/best-time-to-call',path: '/tools/best-time-to-call',getParentRoute: () => rootRouteImport
          })
const RatesCountryRoute = RatesCountryRouteImport.update({
            id: '/rates/$country',path: '/rates/$country',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminTransactionsRoute = AdminTransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => AdminRoute
          })
const AdminSupportRoute = AdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AdminRoute
          })
const AdminSchedulerRoute = AdminSchedulerRouteImport.update({
            id: '/scheduler',path: '/scheduler',getParentRoute: () => AdminRoute
          })
const AdminPhoneNumbersRoute = AdminPhoneNumbersRouteImport.update({
            id: '/phone-numbers',path: '/phone-numbers',getParentRoute: () => AdminRoute
          })
const AdminCallsRoute = AdminCallsRouteImport.update({
            id: '/calls',path: '/calls',getParentRoute: () => AdminRoute
          })
const AdminAffiliatesRoute = AdminAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => AdminRoute
          })
const PublicTermsRoute = PublicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PublicRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRoute
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangRoute
          })
const LangPricingRoute = LangPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => LangRoute
          })
const LangFaqRoute = LangFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => LangRoute
          })
const LangDocsRoute = LangDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => LangRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AdminRoute
          })
const AdminPricingIndexRoute = AdminPricingIndexRouteImport.update({
            id: '/pricing/',path: '/pricing/',getParentRoute: () => AdminRoute
          })
const AdminUsersAccountIdRoute = AdminUsersAccountIdRouteImport.update({
            id: '/users/$accountId',path: '/users/$accountId',getParentRoute: () => AdminRoute
          })
const AdminPricingVersionsRoute = AdminPricingVersionsRouteImport.update({
            id: '/pricing/versions',path: '/pricing/versions',getParentRoute: () => AdminRoute
          })
const AdminPricingGenerateRoute = AdminPricingGenerateRouteImport.update({
            id: '/pricing/generate',path: '/pricing/generate',getParentRoute: () => AdminRoute
          })
const AdminAgentConsoleCallIdRoute = AdminAgentConsoleCallIdRouteImport.update({
            id: '/agent-console/$callId',path: '/agent-console/$callId',getParentRoute: () => AdminRoute
          })
const PublicBlogIndexRoute = PublicBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => PublicRoute
          })
const PublicBlogSlugRoute = PublicBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => PublicRoute
          })
const LangToolsIndexRoute = LangToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => LangRoute
          })
const LangOpenclawIndexRoute = LangOpenclawIndexRouteImport.update({
            id: '/openclaw/',path: '/openclaw/',getParentRoute: () => LangRoute
          })
const LangAccountIndexRoute = LangAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => LangRoute
          })
const LangToolsPhoneValidatorRoute = LangToolsPhoneValidatorRouteImport.update({
            id: '/tools/phone-validator',path: '/tools/phone-validator',getParentRoute: () => LangRoute
          })
const LangToolsCountryCodesRoute = LangToolsCountryCodesRouteImport.update({
            id: '/tools/country-codes',path: '/tools/country-codes',getParentRoute: () => LangRoute
          })
const LangToolsBestTimeToCallRoute = LangToolsBestTimeToCallRouteImport.update({
            id: '/tools/best-time-to-call',path: '/tools/best-time-to-call',getParentRoute: () => LangRoute
          })
const LangRatesCountryRoute = LangRatesCountryRouteImport.update({
            id: '/rates/$country',path: '/rates/$country',getParentRoute: () => LangRoute
          })
const LangOpenclawSetupRoute = LangOpenclawSetupRouteImport.update({
            id: '/openclaw/setup',path: '/openclaw/setup',getParentRoute: () => LangRoute
          })
const LangAccountSettingsRoute = LangAccountSettingsRouteImport.update({
            id: '/account/settings',path: '/account/settings',getParentRoute: () => LangRoute
          })
const LangAccountReferralsRoute = LangAccountReferralsRouteImport.update({
            id: '/account/referrals',path: '/account/referrals',getParentRoute: () => LangRoute
          })
const LangAccountNumbersRoute = LangAccountNumbersRouteImport.update({
            id: '/account/numbers',path: '/account/numbers',getParentRoute: () => LangRoute
          })
const LangAccountBillingRoute = LangAccountBillingRouteImport.update({
            id: '/account/billing',path: '/account/billing',getParentRoute: () => LangRoute
          })
const LangAccountApiRoute = LangAccountApiRouteImport.update({
            id: '/account/api',path: '/account/api',getParentRoute: () => LangRoute
          })
const LangDocsIndexRoute = LangDocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangDocsRoute
          })
const LangDocsApiReferenceRoute = LangDocsApiReferenceRouteImport.update({
            id: '/api-reference',path: '/api-reference',getParentRoute: () => LangDocsRoute
          })
const LangDocsDocSlugRoute = LangDocsDocSlugRouteImport.update({
            id: '/$docSlug',path: '/$docSlug',getParentRoute: () => LangDocsRoute
          })
const LangOpenclawUseCasesIndexRoute = LangOpenclawUseCasesIndexRouteImport.update({
            id: '/openclaw/use-cases/',path: '/openclaw/use-cases/',getParentRoute: () => LangRoute
          })
const LangOpenclawUseCasesCategoryRoute = LangOpenclawUseCasesCategoryRouteImport.update({
            id: '/openclaw/use-cases/$category',path: '/openclaw/use-cases/$category',getParentRoute: () => LangRoute
          })





const LangDocsRouteChildren = {
  LangDocsDocSlugRoute: LangDocsDocSlugRoute,LangDocsApiReferenceRoute: LangDocsApiReferenceRoute,LangDocsIndexRoute: LangDocsIndexRoute
}

const LangDocsRouteWithChildren = LangDocsRoute._addFileChildren(LangDocsRouteChildren)



const LangRouteChildren = {
  LangDocsRoute: LangDocsRouteWithChildren,LangFaqRoute: LangFaqRoute,LangPricingRoute: LangPricingRoute,LangIndexRoute: LangIndexRoute,LangAccountApiRoute: LangAccountApiRoute,LangAccountBillingRoute: LangAccountBillingRoute,LangAccountNumbersRoute: LangAccountNumbersRoute,LangAccountReferralsRoute: LangAccountReferralsRoute,LangAccountSettingsRoute: LangAccountSettingsRoute,LangOpenclawSetupRoute: LangOpenclawSetupRoute,LangRatesCountryRoute: LangRatesCountryRoute,LangToolsBestTimeToCallRoute: LangToolsBestTimeToCallRoute,LangToolsCountryCodesRoute: LangToolsCountryCodesRoute,LangToolsPhoneValidatorRoute: LangToolsPhoneValidatorRoute,LangAccountIndexRoute: LangAccountIndexRoute,LangOpenclawIndexRoute: LangOpenclawIndexRoute,LangToolsIndexRoute: LangToolsIndexRoute,LangOpenclawUseCasesCategoryRoute: LangOpenclawUseCasesCategoryRoute,LangOpenclawUseCasesIndexRoute: LangOpenclawUseCasesIndexRoute
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)




const PublicRouteChildren = {
  PublicPrivacyRoute: PublicPrivacyRoute,PublicTermsRoute: PublicTermsRoute,PublicBlogSlugRoute: PublicBlogSlugRoute,PublicBlogIndexRoute: PublicBlogIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)




const AdminRouteChildren = {
  AdminAffiliatesRoute: AdminAffiliatesRoute,AdminCallsRoute: AdminCallsRoute,AdminPhoneNumbersRoute: AdminPhoneNumbersRoute,AdminSchedulerRoute: AdminSchedulerRoute,AdminSupportRoute: AdminSupportRoute,AdminTransactionsRoute: AdminTransactionsRoute,AdminIndexRoute: AdminIndexRoute,AdminAgentConsoleCallIdRoute: AdminAgentConsoleCallIdRoute,AdminPricingGenerateRoute: AdminPricingGenerateRoute,AdminPricingVersionsRoute: AdminPricingVersionsRoute,AdminUsersAccountIdRoute: AdminUsersAccountIdRoute,AdminPricingIndexRoute: AdminPricingIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,LangRoute: LangRouteWithChildren,PublicRoute: PublicRouteWithChildren,AccountRoute: AccountRoute,AdminRoute: AdminRouteWithChildren,DialerRoute: DialerRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,RatesCountryRoute: RatesCountryRoute,ToolsBestTimeToCallRoute: ToolsBestTimeToCallRoute,ToolsCountryCodesRoute: ToolsCountryCodesRoute,ToolsPhoneValidatorRoute: ToolsPhoneValidatorRoute,ToolsIndexRoute: ToolsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)